export default {
  MuiMenu: {
    paper: {
      maxHeight: "50vh",
    },
  },
};
